import { render, staticRenderFns } from "./TrainerBlock.vue?vue&type=template&id=35fb5c70&scoped=true"
import script from "./TrainerBlock.vue?vue&type=script&lang=js"
export * from "./TrainerBlock.vue?vue&type=script&lang=js"
import style0 from "./TrainerBlock.vue?vue&type=style&index=0&id=35fb5c70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fb5c70",
  null
  
)

export default component.exports